import { Space } from 'antd';
import React from 'react';
import { useModel, useAccess, Access } from 'umi';
import Avatar from './AvatarDropdown';
import styles from './index.less';
import DialogComponent from '../DialogComponent';

export type SiderTheme = 'light' | 'dark';

const GlobalHeaderRight: React.FC = () => {
  const { initialState } = useModel('@@initialState');

  const access = useAccess();

  if (!initialState || !initialState.settings) {
    return null;
  }

  const { navTheme, layout } = initialState.settings;
  let className = styles.right;

  if ((navTheme === 'dark' && layout === 'top') || layout === 'mix') {
    className = `${styles.right}  ${styles.dark}`;
  }
  return (
    <Space className={className}>
      <Access accessible={access.productQAEdit}>
        <DialogComponent />
      </Access>
      <Avatar />
    </Space>
  );
};
export default GlobalHeaderRight;
